module.exports = __webpack_public_path__ + "static/media/movingcleaning.3c5cc4a5.png";